export const $getIcon = (type?: IconType): IconName | null => {
    return iconTypes[type] ?? 'lucide:circle-dashed'
}

export const iconTypes: IconTypes = {
    // crud
    add: 'lucide:plus',
    edit: 'lucide:pencil',
    delete: 'lucide:trash-2',
    clear: 'lucide:x-circle',

    // basics
    check: 'lucide:check',
    none: 'lucide:circle-dashed',
    home: 'lucide:house',
    hint: 'lucide:circle-help',
    success: 'lucide:circle-check-big',
    info: 'lucide:info',
    warning: 'lucide:circle-alert',
    error: 'lucide:triangle-alert',
    loading: 'lucide:loader-circle',
    emergency: 'lucide:octagon-alert',

    // actions
    close: 'lucide:x',
    refresh: 'lucide:refresh-cw',
    filter: 'lucide:funnel',
    search: 'lucide:search',
    save: 'lucide:save',
    restore: 'lucide:timer-reset',
    tool: 'lucide:wrench',
    logout: 'lucide:log-out',
    login: 'lucide:log-in',
    copy: 'lucide:copy',
    show: 'lucide:eye',
    hide: 'lucide:eye-closed',
    link: 'lucide:external-link',
    hyperlink: 'lucide:link',
    locked: 'lucide:lock-keyhole',
    unlocked: 'lucide:lock-keyhole-open',
    send: 'lucide:send',

    // direction
    backwards: 'lucide:chevrons-left',
    left: 'lucide:chevron-left',
    right: 'lucide:chevron-right',
    up: 'lucide:chevron-up',
    down: 'lucide:chevron-down',
    forwards: 'lucide:chevrons-right',

    from: 'lucide:move-left',
    to: 'lucide:move-right',

    // ui
    dropdown: 'lucide:chevrons-up-down',
    menu: 'lucide:ellipsis-vertical',
    bars: 'lucide:menu',
    calendar: 'lucide:calendar',
    clock: 'lucide:clock-4',
    text: 'lucide:align-left',
    globe: 'lucide:globe',
    euro: 'lucide:euro',
    cent: 'majesticons:cent-circle-line',
    iban: 'lucide:building-2',

    // misc
    user: 'lucide:user-round',
    organisations: 'lucide:landmark',
    profile: 'lucide:circle-user-round',
    guardians: 'lucide:shield-user',
    leaders: 'lucide:clipboard-list',
    pass: 'lucide:book-heart',
    history: 'lucide:history',
    participants: 'lucide:backpack',
    submissions: 'lucide:file-pen-line',

    x: 'lucide:x',
    handle: 'lucide:equal',
    location: "lucide:map-pin",
    mail: "lucide:mail",
    email: "lucide:mail",
    phone: "lucide:phone",
    mobile: "lucide:smartphone",
    sms: "lucide:smartphone",
    date: "lucide:calendar",
    male: 'lucide:mars',
    female: 'lucide:venus',
    diverse: 'lucide:non-binary',
    nogender: 'lucide:circle-small',

    string: 'lucide:letter-text',
    numeric: 'lucide:hash',
    boolean: 'lucide:toggle-left',
}
